import Com from "components/styledComp/CommStyledComp";
import React, { useState } from "react";
import CompImg from "./CompImg";
import 에스마리나_전체구성도 from "assets/images/에스마리나_전체구성도.png"
import Modal from "./Modal";

//전체구성도
const System = () => {

    const [showModal, setShowModal] = useState(false);

    const handleImgClick = () => {
        setShowModal(true);
    };

    return (
        <>
            <Com.DivDetailSection border="false">
                <Com.DivDetailHeading>
                    <Com.DetailHeading>마리나 시설 구성도</Com.DetailHeading>
                    <Com.DetailHeadingP>sDevice + sPedestal + MaFims</Com.DetailHeadingP>
                </Com.DivDetailHeading>
                <div className="strategy">
                    <CompImg img={에스마리나_전체구성도} width="100%" height="auto" onClick={handleImgClick}/>
                </div>
                {showModal && (
                <Modal onClose={() => setShowModal(false)}>
                    <img src={에스마리나_전체구성도} alt="Full" style={{ width: "100%" }} />
                </Modal>
            )}
            </Com.DivDetailSection>
        </>
      );
}

export default System;